"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllSkillTags = getAllSkillTags;
exports.getAutoCompleteSkillTags = getAutoCompleteSkillTags;
exports.getSingleSkillTag = getSingleSkillTag;
exports.getSkillTagsSuggestions = getSkillTagsSuggestions;
const config_1 = __importDefault(require("@src/config"));
const axios_1 = require("./clients/axios");
async function getAllSkillTags() {
    const response = await axios_1.client.get(`${config_1.default.api}/0/skill-tag/all`);
    return response.data;
}
async function getAutoCompleteSkillTags(searchedText, selectedOptions) {
    const response = await axios_1.client.get(`${config_1.default.api}/0/skill-tag/search`, { params: { searchedText, selectedOptions } });
    return response.data;
}
async function getSingleSkillTag(tagName) {
    const response = await axios_1.client.get(`${config_1.default.api}/0/skill-tag/${tagName}`);
    return response.data;
}
async function getSkillTagsSuggestions({ searchText, selectedOptionsIds }) {
    const response = await axios_1.client.get(`${config_1.default.api}/0/skill-tag/suggestions`, {
        params: { searchText, selectedOptionsIds },
    });
    return response.data;
}
